import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mpgPercentage',
    standalone: false
})
export class MpgPercentagePipe implements PipeTransform {

  transform(mpg: number, totalMpg: number, decimalPlace?: number): unknown {
    if (mpg && totalMpg) {
      const rawPercentage = (mpg / totalMpg) * 100;
      const boundedPercentage = Math.min(100, Math.max(0, rawPercentage));

      if (Number.isInteger(boundedPercentage)) {
        return boundedPercentage;
      }

      return parseFloat(boundedPercentage.toString()).toFixed(decimalPlace || 0);
    }

    return 0;
  }

}
